import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import LogoInnerImg from "../images/logo-inner.svg";

const SupportPatientHeader = () => {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const handleLogout = () => {
    localStorage.removeItem("supportPatientMobile");
    localStorage.removeItem("supportHcp");
    localStorage.removeItem("supportPatientId");
    localStorage.removeItem("supportPatientToken");
  };

  return (
    <>
      <header className="inner fixed-top">
        <nav className="navbar navbar-expand-lg bg-white">
          <section className="container">
            <div className="navigation d-flex align-items-end w-100">
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleMenu}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className={`offcanvas offcanvas-start border-end-0 ${
                  showMenu ? "show" : "hide"
                }`}
                tabIndex="-1"
              >
                <div className="offcanvas-header d-flex d-lg-none">
                  <img src={LogoInnerImg} className="img-fluid w-75" alt="" />
                  <button
                    type="button"
                    className="btn-close"
                    onClick={toggleMenu}
                  ></button>
                </div>
                <div className="offcanvas-body">
                  <ul className="navbar-nav mb-lg-0">
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-patient-dashboard"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-patient-dashboard"
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-patient-program"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-patient-program"
                      >
                        PROGRAM
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-patient-product"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-patient-product"
                      >
                        Product
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-patient-my-details"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-patient-my-details"
                      >
                        My details
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${
                          location.pathname === "/support-patient-contact-us"
                            ? "active-blue"
                            : ""
                        }`}
                        aria-current="page"
                        to="/support-patient-contact-us"
                      >
                        Contact Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/" onClick={handleLogout}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <Link
                to="/co-pay-patient-dashboard"
                className="w-50 logo-inner ms-auto"
              >
                <img src={LogoInnerImg} className="img-fluid" alt="" />
              </Link>
            </div>
          </section>
        </nav>
      </header>
    </>
  );
};
export default SupportPatientHeader;
